<template lang="pug">
  ev-autocomplete(
    v-model="inputValue"
    :items="items"
    label="Организатор"
    item-text="full_name"
    item-value="id"
    :loading="loading"
    :search-input.sync="name"
    clearable
    v-bind="$attrs"
  )
</template>

<script>
import userService from '@/services/API/user/index';

export default {
  props: {
    value: { type: [Number, String], default: null },
  },
  data() {
    return {
      items: [],
      loading: true,
      name: '',
    };
  },
  computed: {
    inputValue: {
      get() {
        return Number(this.value);
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    name: {
      immediate: true,
      handler() {
        if (this.name && !this.value) {
          this.getAddresses();
        }
      },
    },
  },

  async created() {
    await this.getAddresses();
    await this.getAddress();
  },

  methods: {
    async getAddress() {
      const address = this.items.find((item) => item.id === this.value);
      const params = {
        'search[id]': this.value,
      };
      if (!address && this.value) {
        await userService
          .getOrganizators(this.value, params)
          .then((response) => {
            this.items.push(...response.data.data);
          });
      }
    },

    async getAddresses() {
      const params = {};

      if (this.name) {
        params['search[full_name]'] = this.name;
      }

      this.loading = true;

      const response = await userService.getOrganizators(params);
      this.items = response.data.data;
      this.loading = false;
    },
  },
};
</script>
